import React, { useState } from "react";
import TextArea from "antd/lib/input/TextArea";
import ZModal from "@atoms/ZModal";
import ZIcon, { Icons } from "@atoms/ZIcon";

interface IExpandableTextareaProps {
	value?: string;
	onChange?: (value: string) => void;
	placeholder?: string;
	disabled?: boolean;
}

const ExpandableTextarea: React.FC<IExpandableTextareaProps> = ({
	value,
	onChange,
	placeholder,
	disabled
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [draftValue, setDraftValue] = useState("");

	const handleExpand = () => {
		setDraftValue(value ?? "");
		setModalOpen(true);
	};

	const handleDone = () => {
		onChange?.(draftValue);
		setModalOpen(false);
	};

	const handleCancel = () => {
		setModalOpen(false);
	};

	return (
		<>
			<div className="expandable-textarea-wrapper">
				<TextArea
					value={value}
					onChange={e => onChange?.(e.target.value)}
					placeholder={placeholder}
					disabled={disabled}
					allowClear
					autoSize={{ minRows: 3, maxRows: 6 }}
				/>
				{!disabled && (
					<button
						type="button"
						className="expandable-textarea-expand-btn"
						aria-label="Expand"
						onClick={handleExpand}
					>
						<ZIcon name={Icons.MAXIMIZE} size="sm" />
					</button>
				)}
			</div>
			<ZModal
				title="Description"
				visible={modalOpen}
				onOk={handleDone}
				onCancel={handleCancel}
				okText="Done"
				size="md"
				destroyOnClose
			>
				<TextArea
					value={draftValue}
					onChange={e => setDraftValue(e.target.value)}
					autoSize={{ minRows: 12 }}
					placeholder={placeholder}
					autoFocus
				/>
			</ZModal>
		</>
	);
};

export default ExpandableTextarea;
